import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createRipple, onChildrenDrawerCloseIntegraciones, DrawerCarroCompra, DrawerMasInformacion, DrawerFichaClienteTaller, DrawerFichaClienteSocio } from "../action/actionCreators"
import { getCestaLineasEnAPI, eliminarCestaLineasEnAPI, setCestaLineasEnAPI, vaciarCestaLineasEnAPI, getClienteTallerEnAPI, GetEstadisticasMatriculasPorUsuarioDetalleEnAPI, GetEstadisticasTotalesAnnosEnAPI, GetEstadisticasMatriculasPorUsuarioEnAPI } from "../action/actionCreatorsRequests"
import { traducirPagina, referenciaActualSelect, convertirMoneda, redondeo, MSGOK, convertirAMesACodigo, obtenerFechaLocalObjeto, convertirCodigoAMeses, recortarCadena } from '../librerias/funciones'
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';


import { Select, Card, Modal, Button, Input, Row, Col, Drawer } from 'antd';

import store from "../store";
const { Option } = Select;
const FichaDetalleMatricula = ({ props, configApp }) => {


    return (
        <div>
            <Drawer
                width={"1200px"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ESTADO_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>

                <div className="flex-container-Grow-Tercero" >
                    <div style={{ textAlign: 'inherit' }}>
                        <button className="backgrounNegroClaro soloColorBlanco" aria-label="Close" style={{ border: 'none', width: '61px', height: '61px', padding: '0px', margin: '0px', borderRadius: 'unset' }}
                            onClick={(e) => {
                                props.CERRAR_FICHA(false)
                            }}>
                            <i aria-label="icon: close" className="anticon anticon-close">
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" style={{ fontSize: '16px' }} ><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                                </svg>
                            </i>
                        </button>
                    </div>

                    <div style={{ width: '500px', color: '#fff', verticalAlign: 'middle', paddingLeft: '10px', fontSize: '16px' }}>
                        {props.title}
                    </div>
                </div>


                <div className="p-3">

                    <div style={{ paddingBottom: '20px', color: '#000', fontSize: '16px' }}>
                        <span style={{ fontWeight: 'bold', color: '#999' }}>{props.USUARIO.NOMBRE_USUARIO}</span>

                        <br />
                        <span style={{ fontWeight: 'bold', color: '#000' }}>{props.SELECCIONADO.TITULO === "TOTALES" ? `${traducirPagina("Total_matricula").toUpperCase()} (${props.SELECCIONADO.TOTAL})` 
                            :`${traducirPagina("Total_matricula")} ${props.SELECCIONADO.TITULO} (${props.SELECCIONADO.TOTAL})` } </span>

                        <span style={{ fontWeight: 'bold', color: '#000' }}>{props.FECHA_PARTIDA.TIPO_FECHA === 1 ?`, ${traducirPagina("Total_matricula_durante").toUpperCase()}`  : props.FECHA_PARTIDA.TIPO_FECHA === 2 ?`, ${traducirPagina("Total_matricula_mes").toUpperCase()} ${convertirCodigoAMeses(props.FECHA_PARTIDA.FECHA).toUpperCase()}` :`, ${traducirPagina("Total_matricula_anio").toUpperCase()} ${props.FECHA_PARTIDA.FECHA}`}</span>
                    </div>


                    {props.REGISTRO !== null || props.REGISTRO === undefined ?
                        Object.keys(props.REGISTRO).length > 0 ?
                            <div style={{ height: (configApp.height - 180).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>

                                <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                    <thead>
                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Matriculas")}  </th>
                                            <th style={{ width: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Bastidores")} </th>
                                            <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("Marca")} </th>
                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("Modelo")} </th>
                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Carburante")}  </th>
                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Matriculacion")}  </th>
                                            <th style={{ width: '160px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Fecha_consulta")} </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {props.REGISTRO.REGISTROS.map((matricula) =>
                                            <tr key={matricula.ID} style={{ backgroundColor: '#fff' }}>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{matricula.MATRICULA}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} >{matricula.BASTIDOR}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{matricula.MARCA}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{matricula.MODELO}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{matricula.CARBURANTE}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{matricula.FECHAMATRICULA}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{matricula.FECHA}</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>

                            </div>
                            : 
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                        :
                        null
                    }
                </div>
            </Drawer>
        </div>
    )
}



FichaDetalleMatricula.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    REGISTRO: PropTypes.object,
    USUARIO: PropTypes.object,
    SELECCIONADO: PropTypes.string,
    FECHA_PARTIDA: PropTypes.object
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado
    };
}

export default connect(mapStateToProps)(FichaDetalleMatricula);